export default {
      id: "arrow_right-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#arrow_right",
      toString: function () {
        return this.url;
      }
    }